/**
 * Collaborations data - Client logos with optional testimonials
 * Shows logos in carousel, reveals quote on hover if available
 */

export type Collaboration = {
	name: string;
	logo: string;
	quote?: string;
	title?: string;
};

/**
 * Client collaborations for the carousel
 */
export const collaborations: Collaboration[] = [
	{
		name: "Informa",
		logo: "https://static.wixstatic.com/media/8685fe_164030565c5147bd8ebadbb0e0c36ac5~mv2.webp/v1/fill/w_220,h_101,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Informa_Logo_1Line_Indigo_Solid_RGB.webp",
		quote:
			"Exceptional design work that perfectly captured our brand identity. The attention to detail was remarkable.",
		title: "Director of Facilities",
	},
	{
		name: "Batelco",
		logo: "https://static.wixstatic.com/media/8685fe_09d2b6e1b87b4efdab2a5ca550c46e94~mv2.png/v1/fill/w_220,h_86,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/BATELCO-LOGO-ENG-2022-png-e1651154423547.png",
		quote:
			"Transformed our corporate headquarters into a modern, functional space that our employees love.",
		title: "VP Operations",
	},
	{
		name: "Investcorp",
		logo: "https://static.wixstatic.com/media/8685fe_3acf5aabd4a04a3c9c30470a13e8ed25~mv2.png/v1/fill/w_220,h_137,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Investcorp-web_edited.png",
		quote:
			"Professional, creative, and delivered beyond our expectations. Highly recommended for luxury projects.",
		title: "Property Manager",
	},
	{
		name: "BNP Paribas",
		logo: "https://static.wixstatic.com/media/8685fe_44f4d82015b642d59b25b7b3aecb18af~mv2.png/v1/fill/w_220,h_138,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/bnp-paribas-1_edited.png",
		quote:
			"The blend of Bahraini culture with contemporary design created a truly unique banking environment.",
		title: "Regional Director",
	},
	{
		name: "ABS",
		logo: "https://static.wixstatic.com/media/8685fe_595274fdc5794eb6a45b9e878e4d671e~mv2.png/v1/fill/w_220,h_124,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/ABS-Logo-2018-USE_edited.png",
		quote:
			"Outstanding attention to accessibility and safety standards while maintaining aesthetic excellence.",
		title: "Safety Coordinator",
	},
	{
		name: "BAISP",
		logo: "https://static.wixstatic.com/media/8685fe_d9cc16853af94264a94d1f742184d825~mv2.png/v1/fill/w_220,h_148,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/BAISP_logo.png",
		quote:
			"Brought innovative solutions to our educational spaces that enhanced the learning environment.",
		title: "Facilities Head",
	},
	{
		name: "ZGH",
		logo: "https://static.wixstatic.com/media/8685fe_f0dfeac7e4d24436a58be5b886712598~mv2.png/v1/fill/w_220,h_92,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/ZGH_logon.png",
		quote:
			"Delivered a hospitality project that set new standards for luxury in the region.",
		title: "Development Manager",
	},
];

export default collaborations;
